import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "easing"
    }}>{`easing`}</h1>
    <h4 {...{
      "id": "you-can-pass-an-easing-pattern-for-the-animations"
    }}>{`You can pass an easing pattern for the animations`}</h4>
    <Playground __position={0} __code={'<Carousel\n  easing=\"cubic-bezier(1,.15,.55,1.54)\"\n  tiltEasing=\"cubic-bezier(0.110, 1, 1.000, 0.210)\"\n  transitionMs={700}\n>\n  <Item>1</Item>\n  <Item>2</Item>\n  <Item>3</Item>\n  <Item>4</Item>\n  <Item>5</Item>\n  <Item>6</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Carousel easing="cubic-bezier(1,.15,.55,1.54)" tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)" transitionMs={700} mdxType="Carousel">
        <Item mdxType="Item">1</Item>
        <Item mdxType="Item">2</Item>
        <Item mdxType="Item">3</Item>
        <Item mdxType="Item">4</Item>
        <Item mdxType="Item">5</Item>
        <Item mdxType="Item">6</Item>
    </Carousel>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      